<div *ngIf="showLegend" class="legend">
  <div *ngIf="ticker" class="ticker">{{ ticker }}</div>
  <div
    *ngIf="candlestickLegend$ | async as item"
    class="price-container"
    [class]="getColor(item.open, item.close)"
  >
    ОТКР <span class="color">{{ item.open | delimitNumber }}</span> МАКС
    <span class="color">{{ item.high | delimitNumber }}</span> МИН
    <span class="color">{{ item.low | delimitNumber }}</span> ЗАКР
    <span class="color">{{ item.close | delimitNumber }}</span> СРЕД
    <span class="color">{{ item.avgPrice | delimitNumber }}</span>
    <span class="diff color"
      >{{ displaySign(item.diff) }}{{ item.diff | delimitNumber }}</span
    >
    <span class="diff color"
      >({{ displaySign(item.percentage)
      }}{{ item.percentage | delimitNumber }})%</span
    >
  </div>
</div>
<prlw-simple-loader *ngIf="!chartData"></prlw-simple-loader>
<div #twChart class="container"></div>
